// Global image fallback — when ANY <img> fails to load anywhere on the site,
// automatically retry through the mirror endpoint. Catches:
//   • broken Bluehost WP URLs the migration missed
//   • hardcoded URLs in markdown / bio / page content
//   • images set by future content edits
//
// Prevents infinite retry loops via a `data-mirror-tried` attribute.

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const MIRROR_PREFIX = `${BACKEND}/api/wp-mirror?u=`;

// Domains we'll proxy through the mirror
const PROXY_HOSTS = [
  "flintislamiccenter.com",
  "www.flintislamiccenter.com",
  "themexbd.com",
];

function shouldMirror(src) {
  if (!src) return false;
  if (src.startsWith("data:")) return false;
  if (src.startsWith(MIRROR_PREFIX)) return false;        // already a mirror URL
  if (src.includes("/api/files/")) return false;          // already internal
  if (src.includes("customer-assets.emergentagent.com")) return false; // platform assets
  try {
    const u = new URL(src, window.location.href);
    return PROXY_HOSTS.includes(u.hostname.toLowerCase());
  } catch {
    return false;
  }
}

export function installImageFallback() {
  if (typeof document === "undefined") return;
  // Use capture phase so we run before React's own error handlers.
  document.addEventListener(
    "error",
    (e) => {
      const t = e.target;
      if (!t || t.tagName !== "IMG") return;
      if (t.dataset.mirrorTried === "1") return;
      const src = t.src || t.getAttribute("src");
      if (!shouldMirror(src)) return;
      t.dataset.mirrorTried = "1";
      const fixed = MIRROR_PREFIX + encodeURIComponent(src);
      // Swap src — browser will fetch the new URL automatically.
      t.src = fixed;
    },
    true /* useCapture */
  );
}
